import { merge, cloneDeep } from 'lodash';
import { Contact } from '../../providers/api/dtos';

// Gli attributi con valore undefined vengono impostati a null (ricorsivamente) per evitare che nel merge di Lodash vengano scartati.
// Il che comporta l'impossibilità di cancellare un dato presente, anche nei campi annidati (es. identityDocument).
function deepNullifyUndefined(value: unknown): unknown {
  if (value === undefined) return null;
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([k, v]) => [k, deepNullifyUndefined(v)]),
    );
  }
  return value;
}

export function mergeContact(existingContact?: Contact, newContactValues?: Partial<Contact>): Partial<Contact> {
  return merge(cloneDeep(existingContact || {}), deepNullifyUndefined(newContactValues || {}) as Partial<Contact>);
}
